(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daily-nuuds-box-visual-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const install = (config) => {
      if (config.dataset.installed === 'true') return true;

      const landing = document.querySelector('daily-nuuds-landing');
      const builder = landing?.querySelector('[data-box-builder]');
      if (!landing || !builder || typeof landing.renderBoxVisuals !== 'function') return false;

      const assets = {
        emptyBox: config.dataset.emptyBox || '',
        texture3: config.getAttribute('data-texture-3') || '',
        texture5: config.getAttribute('data-texture-5') || '',
        masks3: [
          config.getAttribute('data-mask-3-1') || '',
          config.getAttribute('data-mask-3-2') || '',
          config.getAttribute('data-mask-3-3') || ''
        ],
        masks5: [
          config.getAttribute('data-mask-5-1') || '',
          config.getAttribute('data-mask-5-2') || '',
          config.getAttribute('data-mask-5-3') || '',
          config.getAttribute('data-mask-5-4') || '',
          config.getAttribute('data-mask-5-5') || ''
        ]
      };

      const buildVisual = (visual) => {
        visual.replaceChildren();
        visual.setAttribute('data-box-v3-ready', '');

        const base = document.createElement('img');
        base.className = 'dn-box-v3__base';
        base.alt = 'Daily Nuuds canlı kutu';
        base.loading = 'lazy';
        base.width = 1024;
        base.height = 1024;

        const stack = document.createElement('span');
        stack.className = 'dn-box-v3__stack';
        stack.setAttribute('aria-hidden', 'true');

        for (let index = 0; index < 5; index += 1) {
          const slot = document.createElement('span');
          slot.className = 'dn-box-v3__slot';
          slot.dataset.boxV3Slot = String(index + 1);

          const color = document.createElement('span');
          color.className = 'dn-box-v3__color';

          const texture = document.createElement('img');
          texture.className = 'dn-box-v3__texture';
          texture.alt = '';
          texture.loading = 'lazy';
          texture.width = 1000;
          texture.height = 1000;

          const highlight = document.createElement('span');
          highlight.className = 'dn-box-v3__highlight';

          slot.append(color, texture, highlight);
          stack.append(slot);
        }

        visual.append(base, stack);
      };

      builder.querySelectorAll('[data-box-visual]').forEach(buildVisual);

      landing.renderBoxVisuals = function renderBoxVisualsV3(selected) {
        const pack = String(this.packSize);
        const packSize = Number(pack);
        const masks = pack === '3' ? assets.masks3 : assets.masks5;
        const textureUrl = pack === '3' ? assets.texture3 : assets.texture5;

        this.builder.querySelectorAll('[data-box-visual]').forEach((visual) => {
          visual.classList.toggle('is-pack-3', pack === '3');
          visual.classList.toggle('is-pack-5', pack === '5');

          const base = visual.querySelector('.dn-box-v3__base');
          if (base && assets.emptyBox && base.getAttribute('src') !== assets.emptyBox) {
            base.setAttribute('src', assets.emptyBox);
          }

          visual.querySelectorAll('[data-box-v3-slot]').forEach((slot, index) => {
            const chosen = selected[index];
            const maskUrl = masks[index] || '';
            const visible = index < packSize && Boolean(chosen) && Boolean(maskUrl);
            const texture = slot.querySelector('.dn-box-v3__texture');

            slot.hidden = index >= packSize;
            slot.style.setProperty('--dn-box-v3-mask', maskUrl ? `url("${maskUrl}")` : 'none');
            slot.style.setProperty('--dn-box-v3-color', chosen?.value || 'transparent');
            slot.classList.toggle('is-filled', visible);
            slot.setAttribute('aria-label', chosen?.name || 'Boş kutu gözü');

            if (texture && textureUrl && texture.getAttribute('src') !== textureUrl) {
              texture.setAttribute('src', textureUrl);
            }
          });
        });
      };

      config.dataset.installed = 'true';
      landing.renderBuilder();
      return true;
    };

    const initialize = () => {
      document.querySelectorAll('.dn-box-v3-config').forEach((config) => {
        let attempts = 0;
        const tryInstall = () => {
          attempts += 1;
          if (install(config) || attempts >= 50) return;
          window.setTimeout(tryInstall, 100);
        };
        tryInstall();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-box-visual-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const colorNames = ['Hot Cocoa', 'Pepper Red', 'Bare Black', 'Nuud Beige', 'Sky Blue'];
    const colorSlugs = {
      'Hot Cocoa': 'hot-cocoa',
      'Pepper Red': 'pepper-red',
      'Bare Black': 'bare-black',
      'Nuud Beige': 'nuud-beige',
      'Sky Blue': 'sky-blue'
    };

    const install = (config) => {
      if (config.dataset.installed === 'true') return true;

      const landing = document.querySelector('daily-nuuds-landing');
      const builder = landing?.querySelector('[data-box-builder]');
      if (!landing || !builder || typeof landing.renderBoxVisuals !== 'function') return false;

      const assets = {
        base: {
          3: config.getAttribute('data-base-3') || '',
          5: config.getAttribute('data-base-5') || ''
        },
        layers: {
          3: {},
          5: {}
        }
      };

      [3, 5].forEach((pack) => {
        colorNames.forEach((name) => {
          assets.layers[pack][name] = config.getAttribute(`data-layer-${pack}-${colorSlugs[name]}`) || '';
        });
      });

      const buildVisual = (visual) => {
        visual.replaceChildren();
        visual.setAttribute('data-box-v5-ready', '');

        const base = document.createElement('img');
        base.className = 'dn-box-v5__base';
        base.alt = 'Daily Nuuds canlı kutu';
        base.loading = 'lazy';
        base.decoding = 'async';
        base.width = 960;
        base.height = 960;

        const stack = document.createElement('span');
        stack.className = 'dn-box-v5__stack';
        stack.setAttribute('aria-hidden', 'true');

        for (let index = 0; index < 5; index += 1) {
          const slot = document.createElement('span');
          slot.className = 'dn-box-v5__slot';
          slot.dataset.boxV5Slot = String(index + 1);

          const image = document.createElement('img');
          image.className = 'dn-box-v5__slot-image';
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 960;
          image.height = 960;
          image.hidden = true;

          slot.append(image);
          stack.append(slot);
        }

        visual.append(base, stack);
      };

      builder.querySelectorAll('[data-box-visual]').forEach(buildVisual);

      landing.renderBoxVisuals = function renderBoxVisualsV5(selected) {
        const pack = Number(this.packSize) === 3 ? 3 : 5;
        const baseUrl = assets.base[pack];

        this.builder.querySelectorAll('[data-box-visual]').forEach((visual) => {
          visual.classList.toggle('is-pack-3', pack === 3);
          visual.classList.toggle('is-pack-5', pack === 5);

          const base = visual.querySelector('.dn-box-v5__base');
          if (base && baseUrl && base.getAttribute('src') !== baseUrl) {
            base.setAttribute('src', baseUrl);
          }

          visual.querySelectorAll('[data-box-v5-slot]').forEach((slot, index) => {
            const chosen = selected[index];
            const layerUrl = chosen ? assets.layers[pack][chosen.name] || '' : '';
            const visible = index < pack && Boolean(chosen) && Boolean(layerUrl);
            const image = slot.querySelector('.dn-box-v5__slot-image');

            slot.hidden = index >= pack;
            slot.classList.toggle('is-filled', visible);
            slot.setAttribute('aria-label', chosen?.name || 'Boş kutu gözü');

            if (!image) return;
            image.hidden = !visible;
            if (visible && image.getAttribute('src') !== layerUrl) {
              image.setAttribute('src', layerUrl);
            }
          });
        });
      };

      config.dataset.installed = 'true';
      landing.renderBuilder();
      return true;
    };

    const initialize = () => {
      document.querySelectorAll('.dn-box-v5-config').forEach((config) => {
        let attempts = 0;
        const tryInstall = () => {
          attempts += 1;
          if (install(config) || attempts >= 50) return;
          window.setTimeout(tryInstall, 100);
        };
        tryInstall();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('daily-nuuds-finder')) return;

    class DailyNuudsFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.answers = {};
        this.quizShell = this.querySelector('[data-quiz-shell]');
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.resultShell = this.querySelector('[data-result-shell]');
        this.resultCards = Array.from(this.querySelectorAll('[data-product-result]'));
        this.progressBar = this.querySelector('[data-progress-bar]');
        this.progressLabel = this.querySelector('[data-progress-label]');
        this.progressStatus = this.querySelector('[data-progress-status]');
        this.summary = this.querySelector('[data-answer-summary]');

        this.querySelector('[data-quiz-start]')?.addEventListener('click', (event) => {
          event.preventDefault();
          this.quizShell?.scrollIntoView({ behavior: this.motionBehavior(), block: 'start' });
          this.pushDataLayer('daily_nuuds_quiz_started', {});
        });

        this.querySelector('[data-products-jump]')?.addEventListener('click', (event) => {
          const target = this.querySelector(event.currentTarget.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: this.motionBehavior(), block: 'start' });
          this.pushDataLayer('daily_nuuds_products_viewed', { source: 'hero_jump' });
        });

        this.querySelectorAll('[data-answer]').forEach((button) => {
          button.addEventListener('click', () => this.selectAnswer(button));
        });

        this.querySelectorAll('[data-back-to]').forEach((button) => {
          button.addEventListener('click', () => this.showStep(Number(button.dataset.backTo)));
        });

        this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.restart());

        this.querySelectorAll('[data-quiz-product-form]').forEach((form) => {
          form.addEventListener('submit', () => this.trackAddToCart(form));
        });
      }

      motionBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      selectAnswer(button) {
        const key = button.dataset.answerKey;
        const value = button.dataset.answerValue;
        const label = button.dataset.answerLabel;
        if (!key || !value) return;

        this.answers[key] = { value, label };
        button.parentElement?.querySelectorAll('[data-answer]').forEach((option) => {
          option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
        });

        if (key === 'priority') this.showStep(2);
        if (key === 'usage') this.showStep(3);
        if (key === 'package') this.showResult(value);
      }

      showStep(stepNumber) {
        this.steps.forEach((step) => {
          step.hidden = Number(step.dataset.step) !== stepNumber;
        });
        if (this.resultShell) this.resultShell.hidden = true;

        this.updateProgress(stepNumber, stepNumber === 1 ? 'Başlayalım' : 'Devam ediyor');
        const activeStep = this.steps.find((step) => Number(step.dataset.step) === stepNumber);
        activeStep?.scrollIntoView({ behavior: this.motionBehavior(), block: 'nearest' });
      }

      showResult(packageValue) {
        this.steps.forEach((step) => { step.hidden = true; });
        if (this.resultShell) this.resultShell.hidden = false;

        let activeCard;
        this.resultCards.forEach((card) => {
          card.hidden = card.dataset.productResult !== packageValue;
          if (!card.hidden) activeCard = card;
        });

        this.updateProgress(3, 'Önerin hazır');
        this.renderSummary();
        this.updateLineItemProperties();
        this.trackCompletion(activeCard);
        this.resultShell?.scrollIntoView({ behavior: this.motionBehavior(), block: 'nearest' });
      }

      updateProgress(stepNumber, status) {
        const normalizedStep = Math.min(Math.max(stepNumber, 1), 3);
        if (this.progressLabel) this.progressLabel.textContent = `${normalizedStep} / 3`;
        if (this.progressStatus) this.progressStatus.textContent = status;
        if (this.progressBar) this.progressBar.style.width = `${(normalizedStep / 3) * 100}%`;
      }

      renderSummary() {
        if (!this.summary) return;
        this.summary.replaceChildren();
        ['priority', 'usage', 'package'].forEach((key) => {
          const answer = this.answers[key];
          if (!answer) return;
          const pill = document.createElement('span');
          pill.textContent = answer.label;
          this.summary.appendChild(pill);
        });
      }

      updateLineItemProperties() {
        this.querySelectorAll('[data-quiz-property]').forEach((input) => {
          const answer = this.answers[input.dataset.quizProperty];
          input.value = answer?.label || '';
        });
      }

      trackingPayload(activeCard) {
        const url = new URL(window.location.href);
        const payload = {
          quiz_version: 'daily-nuuds-v1',
          priority: this.answers.priority?.label || '',
          priority_key: this.answers.priority?.value || '',
          usage: this.answers.usage?.label || '',
          usage_key: this.answers.usage?.value || '',
          package: this.answers.package?.label || '',
          package_key: this.answers.package?.value || '',
          recommendation_product_id: activeCard?.dataset.productId || '',
          recommendation_product_title: activeCard?.dataset.productTitle || '',
          recommendation_product_handle: activeCard?.dataset.productHandle || '',
          recommendation_product_url: activeCard?.dataset.productUrl || '',
          recommendation_product_image_url: activeCard?.dataset.productImageUrl || '',
          recommendation_product_price: Number(activeCard?.dataset.productPrice || 0),
          landing_url: url.origin + url.pathname,
          utm_source: url.searchParams.get('utm_source') || '',
          utm_medium: url.searchParams.get('utm_medium') || '',
          utm_campaign: url.searchParams.get('utm_campaign') || '',
          utm_content: url.searchParams.get('utm_content') || '',
          utm_term: url.searchParams.get('utm_term') || ''
        };

        return payload;
      }

      trackCompletion(activeCard) {
        const payload = this.trackingPayload(activeCard);
        const eventName = this.dataset.klaviyoEvent || 'Daily Nuuds Quiz Completed';

        try {
          if (window.klaviyo && typeof window.klaviyo.track === 'function') {
            const result = window.klaviyo.track(eventName, payload);
            if (result && typeof result.catch === 'function') result.catch(() => {});
          } else {
            window._learnq = window._learnq || [];
            window._learnq.push(['track', eventName, payload]);
          }
        } catch (error) {
          console.warn('Daily Nuuds quiz event could not be sent to Klaviyo.', error);
        }

        this.pushDataLayer('daily_nuuds_quiz_completed', payload);

        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', 'DailyNuudsQuizCompleted', payload);
        }
      }

      trackAddToCart(form) {
        const card = form.closest('[data-product-result]');
        const payload = this.trackingPayload(card);
        const variantField = form.querySelector('[name="id"]');
        payload.recommendation_variant_id = variantField?.value || '';
        payload.recommendation_variant_title = variantField?.selectedOptions?.[0]?.textContent?.trim() || '';
        this.pushDataLayer('daily_nuuds_quiz_add_to_cart', payload);

        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', 'DailyNuudsQuizAddToCart', payload);
        }
      }

      pushDataLayer(event, payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...payload });
      }

      restart() {
        this.answers = {};
        this.querySelectorAll('[data-answer]').forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });
        this.showStep(1);
      }
    }

    customElements.define('daily-nuuds-finder', DailyNuudsFinder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-home-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const COLOR_ORDER = ['Hot Cocoa', 'Pepper Red', 'Bare Black', 'Nuud Beige', 'Sky Blue', 'Balerina Pink'];
    const GIFT_COLOR_ORDER = [...COLOR_ORDER];
    const GIFT_VARIANT_TITLES = {
      'Hot Cocoa': 'Kahve',
      'Pepper Red': 'Kırmızı',
      'Bare Black': 'Siyah',
      'Nuud Beige': 'Bej',
      'Sky Blue': 'Mavi',
      'Balerina Pink': 'Pembe'
    };
    const MIXED_COMPONENT_ORDER = [
      ['Classic Bikini', 'Hot Cocoa'],
      ['Classic Bikini', 'Pepper Red'],
      ['Classic Bikini', 'Bare Black'],
      ['Classic Bikini', 'Nuud Beige'],
      ['Classic Bikini', 'Sky Blue'],
      ['Classic Bikini', 'Balerina Pink'],
      ['Thong', 'Bare Black'],
      ['Thong', 'Nuud Beige'],
      ['Thong', 'Balerina Pink']
    ];

    const normalize = (value) => String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const numericId = (value) => {
      const match = String(value || '').match(/(\d+)$/);
      return match ? Number(match[1]) : null;
    };

    class DnHomeBoxBuilder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.pack = 5;
        this.sequence = [];
        this.cutSequence = [];
        this.activeCut = 'Classic Bikini';
        this.giftColor = '';
        this.pending = false;
        this.ready = false;
        this.products = {};
        this.variantCache = new Map();
        this.variantErrors = new Map();
        this.variantLookupKey = '';
        this.variantLookupToken = 0;

        this.querySelectorAll('[data-product-json]').forEach((script) => {
          try {
            this.products[script.dataset.productJson] = JSON.parse(script.textContent || '{}');
          } catch (error) {
            this.products[script.dataset.productJson] = {};
          }
        });

        this.giftProduct = {};
        if (this.giftEnabled) {
          try {
            this.giftProduct = JSON.parse(this.querySelector('[data-gift-product-json]')?.textContent || '{}');
          } catch (error) {
            this.giftProduct = {};
          }
        }

        this.planButtons = [...this.querySelectorAll('[data-pack]')];
        this.cutButtons = [...this.querySelectorAll('[data-cut]')];
        this.colorCards = [...this.querySelectorAll('[data-color]')];
        this.box = this.querySelector('[data-box]');
        this.base = this.querySelector('[data-box-base]');
        this.slots = [...this.querySelectorAll('[data-box-slot]')];
        this.giftPanel = this.querySelector('[data-gift]');
        this.giftOptions = this.querySelector('.dnhb__gift-options');
        this.addButton = this.querySelector('[data-add-cart]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.error = this.querySelector('[data-error]');
        this.preview = this.querySelector('.dnhb__preview');
        this.action = this.querySelector('.dnhb__action');
        this.scrollToken = 0;

        this.colors = Object.fromEntries(this.colorCards.map((card) => [card.dataset.color, {
          card,
          slug: card.dataset.slug,
          value: card.dataset.value,
          cuts: String(card.dataset.cuts || 'Classic Bikini').split('|').map((cut) => cut.trim()).filter(Boolean),
          enabled: card.dataset.enabled !== 'false',
          count: 0
        }]));

        if (this.giftEnabled) this.installGiftOptions();
        this.bindEvents();
        this.setupMobilePreview();
        this.setPack(5);
      }

      disconnectedCallback() {
        this.mobileObserver?.disconnect();
        if (this.mobileMedia && this.mobileMediaHandler) {
          if (this.mobileMedia.removeEventListener) this.mobileMedia.removeEventListener('change', this.mobileMediaHandler);
          else this.mobileMedia.removeListener?.(this.mobileMediaHandler);
        }
        this.closest('.dnhb')?.classList.remove('has-mobile-preview-fixed');
      }

      get giftEnabled() {
        return this.dataset.giftEnabled === 'true';
      }

      bindEvents() {
        this.planButtons.forEach((button) => {
          button.addEventListener('click', () => this.setPack(Number(button.dataset.pack)));
        });

        this.cutButtons.forEach((button) => {
          button.addEventListener('click', () => this.setCut(button.dataset.cut));
        });

        this.colorCards.forEach((card) => {
          const name = card.dataset.color;
          card.querySelector('[data-add-color]')?.addEventListener('click', () => this.changeColor(name, 1));
          card.querySelector('[data-plus]')?.addEventListener('click', () => this.changeColor(name, 1));
          card.querySelector('[data-minus]')?.addEventListener('click', () => this.changeColor(name, -1));
          if (this.giftEnabled) {
            card.querySelector('[data-select-gift]')?.addEventListener('click', () => {
              const variant = this.findGiftVariant(name);
              if (this.pack !== 5 || !variant || variant.available === false || this.pending) return;
              this.giftColor = name;
              this.render();
            });
          }
        });

        this.addButton?.addEventListener('click', () => this.addToCart());
      }

      installGiftOptions() {
        if (!this.giftEnabled || !this.giftOptions) return;
        this.giftOptions.replaceChildren();

        GIFT_COLOR_ORDER.forEach((name) => {
          const color = this.colors[name];
          if (!color) return;
          const variant = this.findGiftVariant(name);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dnhb__gift-option';
          button.dataset.giftColor = name;
          button.setAttribute('aria-pressed', 'false');
          button.style.setProperty('--gift-color', color.value);
          button.disabled = !variant || variant.available === false;
          button.innerHTML = `<i aria-hidden="true"></i><span>${name}</span>`;
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const firstSelection = !this.giftColor;
            this.scrollToken += 1;
            this.giftColor = name;
            this.render();
            if (firstSelection) this.scheduleStageScroll(this.action);
          });
          this.giftOptions.append(button);
        });
      }

      setPack(pack) {
        if (![3, 5].includes(pack)) return;
        this.scrollToken += 1;
        const changed = this.pack !== pack;
        this.pack = pack;
        if (changed) {
          this.sequence = [];
          this.cutSequence = [];
          this.giftColor = '';
          Object.values(this.colors).forEach((color) => { color.count = 0; });
        }
        this.render();
      }

      setCut(cut) {
        if (!['Classic Bikini', 'Thong'].includes(cut) || this.activeCut === cut || this.pending) return;
        this.scrollToken += 1;
        this.activeCut = cut;
        this.render();
      }

      supportsCut(name, cut = this.activeCut) {
        return Boolean(this.colors[name]?.cuts?.includes(cut));
      }

      countForCut(name, cut = this.activeCut) {
        return this.sequence.reduce((count, colorName, index) => (
          colorName === name && (this.cutSequence[index] || 'Classic Bikini') === cut ? count + 1 : count
        ), 0);
      }

      cutSummary() {
        const totals = { 'Classic Bikini': 0, Thong: 0 };
        this.cutSequence.forEach((cut) => {
          const name = cut || 'Classic Bikini';
          if (Object.prototype.hasOwnProperty.call(totals, name)) totals[name] += 1;
        });
        return ['Classic Bikini', 'Thong']
          .map((cut) => totals[cut] > 0 ? `${totals[cut]} ${cut}` : '')
          .filter(Boolean)
          .join(' + ');
      }

      selectionDetails() {
        return this.sequence
          .map((name, index) => `${this.cutSequence[index] || 'Classic Bikini'} · ${name}`)
          .join(' + ');
      }

      changeColor(name, delta) {
        const color = this.colors[name];
        if (!color?.enabled || !this.supportsCut(name) || this.pending) return;
        const previousTotal = this.sequence.length;
        this.scrollToken += 1;

        if (delta > 0) {
          if (this.sequence.length >= this.pack) return;
          color.count += 1;
          this.sequence.push(name);
          this.cutSequence.push(this.activeCut);
        } else {
          if (this.countForCut(name) <= 0) return;
          let index = -1;
          for (let position = this.sequence.length - 1; position >= 0; position -= 1) {
            if (this.sequence[position] === name && (this.cutSequence[position] || 'Classic Bikini') === this.activeCut) {
              index = position;
              break;
            }
          }
          if (index < 0) return;
          color.count -= 1;
          this.sequence.splice(index, 1);
          this.cutSequence.splice(index, 1);
          this.giftColor = '';
        }

        this.render();

        const completedNow = delta > 0 && previousTotal < this.pack && this.sequence.length === this.pack;
        if (completedNow) {
          const target = this.pack === 5 && this.giftEnabled && this.giftPanel && !this.giftPanel.hidden
            ? this.giftPanel
            : this.action;
          this.scheduleStageScroll(target);
        }
      }

      scheduleStageScroll(target) {
        if (!target) return;
        const token = ++this.scrollToken;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (token !== this.scrollToken || !target.isConnected) return;
            const viewport = window.visualViewport;
            const viewportTop = viewport?.offsetTop || 0;
            const viewportBottom = viewportTop + (viewport?.height || window.innerHeight);
            const targetRect = target.getBoundingClientRect();
            if (targetRect.top >= viewportTop + 16 && targetRect.bottom <= viewportBottom - 16) return;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.scrollIntoView({
              behavior: reducedMotion ? 'auto' : 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          });
        });
      }

      setupMobilePreview() {
        this.mobileMedia = window.matchMedia('(max-width: 560px)');
        this.mobileVisible = false;
        this.mobileMediaHandler = () => this.updateMobilePreview();
        if (this.mobileMedia.addEventListener) this.mobileMedia.addEventListener('change', this.mobileMediaHandler);
        else this.mobileMedia.addListener?.(this.mobileMediaHandler);

        if ('IntersectionObserver' in window) {
          this.mobileObserver = new IntersectionObserver(([entry]) => {
            this.mobileVisible = Boolean(entry?.isIntersecting);
            this.updateMobilePreview();
          }, { threshold: 0 });
          this.mobileObserver.observe(this);
        } else {
          this.mobileVisible = true;
          this.updateMobilePreview();
        }
      }

      updateMobilePreview() {
        const active = Boolean(this.mobileMedia?.matches && this.mobileVisible && !this.pending);
        this.classList.toggle('is-mobile-preview-fixed', active);
        this.closest('.dnhb')?.classList.toggle('has-mobile-preview-fixed', active);
      }

      hasMixedCuts() {
        const cuts = new Set(this.cutSequence.map((cut) => cut || 'Classic Bikini'));
        return cuts.has('Classic Bikini') && cuts.has('Thong');
      }

      colorVariantTitle() {
        return COLOR_ORDER
          .map((name) => this.colors[name]?.count > 0 ? `${this.colors[name].count} ${name}` : '')
          .filter(Boolean)
          .join(' + ');
      }

      mixedVariantTitle() {
        return MIXED_COMPONENT_ORDER
          .map(([cut, name]) => {
            const count = this.countForCut(name, cut);
            if (!count) return '';
            const cutToken = cut === 'Classic Bikini' ? 'Classic' : 'Thong';
            return `${count} ${cutToken} ${name}`;
          })
          .filter(Boolean)
          .join(' + ');
      }

      variantTitle() {
        return this.hasMixedCuts() ? this.mixedVariantTitle() : this.colorVariantTitle();
      }

      productKey() {
        const cuts = new Set(this.cutSequence.map((cut) => cut || 'Classic Bikini'));
        if (cuts.has('Classic Bikini') && cuts.has('Thong')) return `${this.pack}-mixed`;
        if (cuts.has('Thong')) return `${this.pack}-thong`;
        return String(this.pack);
      }

      variantCacheKey() {
        return `${this.productKey()}::${this.variantTitle()}`;
      }

      selectedVariant() {
        const cached = this.variantCache.get(this.variantCacheKey());
        return cached && !cached.missing ? cached : null;
      }

      async resolveSelectedVariant() {
        if (this.sequence.length !== this.pack) return;

        const productKey = this.productKey();
        const product = this.products[productKey] || {};
        const title = this.variantTitle();
        const cacheKey = `${productKey}::${title}`;

        if (!product.handle || !title || this.variantCache.has(cacheKey) || this.variantErrors.has(cacheKey)) return;
        if (this.variantLookupKey === cacheKey) return;

        const token = ++this.variantLookupToken;
        this.variantLookupKey = cacheKey;
        this.render();

        const query = `
          query BuilderVariant($handle: String!, $optionName: String!, $title: String!) {
            product(handle: $handle) {
              variantBySelectedOptions(
                selectedOptions: [{ name: $optionName, value: $title }]
                ignoreUnknownOptions: false
                caseInsensitiveMatch: false
              ) {
                id
                title
                availableForSale
                price { amount currencyCode }
              }
            }
          }
        `;

        try {
          const response = await fetch('/api/2026-07/graphql.json', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              query,
              variables: {
                handle: product.handle,
                optionName: product.optionName || 'Kutu İçeriği',
                title
              }
            })
          });

          const payload = await response.json();
          if (!response.ok || payload.errors?.length) {
            throw new Error(payload.errors?.[0]?.message || 'Kombinasyon doğrulanamadı.');
          }

          const variant = payload.data?.product?.variantBySelectedOptions;
          if (token !== this.variantLookupToken) return;

          this.variantCache.set(cacheKey, variant ? {
            id: variant.id,
            title: variant.title,
            available: variant.availableForSale !== false,
            price: variant.price?.amount || ''
          } : { missing: true });
        } catch (error) {
          if (token !== this.variantLookupToken) return;
          this.variantErrors.set(cacheKey, error.message || 'Kombinasyon doğrulanamadı.');
        } finally {
          if (token !== this.variantLookupToken) return;
          this.variantLookupKey = '';
          this.render();

          if (this.selectedVariant() && this.pack === 5 && this.giftEnabled && !this.giftColor) {
            this.scheduleStageScroll(this.giftPanel);
          }
        }
      }

      findGiftVariant(name) {
        const wanted = GIFT_VARIANT_TITLES[name] || name;
        return (this.giftProduct?.variants || []).find((variant) => normalize(variant.title) === normalize(wanted)) || null;
      }

      layerUrl(pack, name) {
        const color = this.colors[name];
        if (!color || !this.box) return '';
        return this.box.getAttribute(`data-layer-${pack}-${color.slug}`) || '';
      }

      renderBox() {
        if (!this.box || !this.base) return;
        this.box.classList.toggle('is-pack-3', this.pack === 3);
        this.box.classList.toggle('is-pack-5', this.pack === 5);
        const baseUrl = this.box.getAttribute(`data-base-${this.pack}`) || '';
        if (baseUrl && this.base.getAttribute('src') !== baseUrl) this.base.setAttribute('src', baseUrl);
        this.base.alt = `Boş ${this.pack}’li Daily Nuuds kutusu`;

        this.slots.forEach((slot, index) => {
          const name = this.sequence[index];
          const color = name ? this.colors[name] : null;
          const image = slot.querySelector('img');
          const url = name ? this.layerUrl(this.pack, name) : '';
          const hasFallback = Boolean(name) && !url && Boolean(color?.value);
          const visible = index < this.pack && Boolean(name) && Boolean(url || color?.value);
          slot.hidden = index >= this.pack;
          slot.classList.toggle('is-filled', visible);
          slot.classList.toggle('is-color-fallback', hasFallback);
          slot.style.setProperty('--dnhb-slot-color', color?.value || 'transparent');
          if (image && url && image.getAttribute('src') !== url) image.setAttribute('src', url);
          if (image && (!visible || !url)) image.removeAttribute('src');
        });
      }

      render() {
        const total = this.sequence.length;
        const remaining = Math.max(this.pack - total, 0);
        const cacheKey = this.variantCacheKey();
        const variant = total === this.pack ? this.selectedVariant() : null;
        const variantMissing = total === this.pack && this.variantCache.get(cacheKey)?.missing === true;
        const variantError = total === this.pack ? this.variantErrors.get(cacheKey) : '';
        const variantResolving = total === this.pack && !variant && !variantMissing && !variantError;
        if (variantResolving) this.resolveSelectedVariant();
        const boxReady = total === this.pack && Boolean(variant) && variant.available !== false;
        const giftVariant = this.giftColor ? this.findGiftVariant(this.giftColor) : null;
        const giftRequired = this.pack === 5 && this.giftEnabled;
        const giftReady = !giftRequired || Boolean(giftVariant) && giftVariant.available !== false;
        const ready = boxReady && giftReady;
        this.ready = ready;

        this.planButtons.forEach((button) => {
          const active = Number(button.dataset.pack) === this.pack;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        this.cutButtons.forEach((button) => {
          const active = button.dataset.cut === this.activeCut;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        this.colorCards.forEach((card) => {
          const color = this.colors[card.dataset.color];
          const availableForCut = this.supportsCut(card.dataset.color);
          const count = this.countForCut(card.dataset.color);
          card.classList.toggle('is-cut-unavailable', !availableForCut);
          card.classList.toggle('has-items', count > 0);
          const cutLabel = card.querySelector('[data-cut-label]');
          if (cutLabel) cutLabel.textContent = this.activeCut.toLocaleUpperCase('tr-TR');
          const image = card.querySelector('.dnhb__color-image img');
          const imageUrl = this.activeCut === 'Thong' ? image?.dataset.thongImage : image?.dataset.classicImage;
          if (image && imageUrl && image.getAttribute('src') !== imageUrl) image.setAttribute('src', imageUrl);
          if (image) image.alt = `${card.dataset.color} ${this.activeCut} Daily Nuuds`;
          const countElement = card.querySelector('[data-color-count]');
          if (countElement) countElement.textContent = String(count);
          const minus = card.querySelector('[data-minus]');
          const plus = card.querySelector('[data-plus]');
          const add = card.querySelector('[data-add-color]');
          const giftOnly = card.querySelector('[data-select-gift]');
          if (minus) minus.disabled = !availableForCut || count <= 0 || this.pending;
          if (plus) plus.disabled = !availableForCut || !color?.enabled || total >= this.pack || this.pending;
          if (add) {
            add.disabled = !availableForCut || !color?.enabled || total >= this.pack || this.pending;
            add.setAttribute('aria-label', `${card.dataset.color} ${this.activeCut} ekle`);
          }
          if (giftOnly) {
            const giftVariantForCard = this.findGiftVariant(card.dataset.color);
            giftOnly.disabled = this.pack !== 5 || !this.giftEnabled || !giftVariantForCard || giftVariantForCard.available === false || this.pending;
            card.classList.toggle('is-disabled', giftOnly.disabled);
            card.classList.toggle('is-gift-selected', this.giftColor === card.dataset.color);
          }
        });

        const countText = `${total} / ${this.pack}`;
        this.querySelector('[data-status-count]').textContent = `${countText} renk seçildi`;
        this.querySelector('[data-preview-count]').textContent = countText;
        this.querySelector('[data-preview-title]').textContent = `${this.pack}’Lİ KUTUN`;
        this.querySelector('[data-progress]').style.width = `${(total / this.pack) * 100}%`;

        const statusMessage = this.querySelector('[data-status-message]');
        if (variantResolving) statusMessage.textContent = 'Kombinasyon doğrulanıyor…';
        else if (variantError) statusMessage.textContent = 'Kombinasyon doğrulanamadı. Lütfen bir seçimi değiştirip tekrar dene.';
        else if (!boxReady && total === this.pack) statusMessage.textContent = 'Bu kesim ve renk kombinasyonu şu an mevcut değil.';
        else if (giftRequired && !giftReady && total === this.pack) statusMessage.textContent = 'Hediye Classic Bikini rengini seç.';
        else if (boxReady && giftReady) statusMessage.textContent = 'Kutun hazır.';
        else statusMessage.textContent = '';

        const selection = this.querySelector('[data-selection]');
        selection.textContent = total > 0
          ? `${this.selectionDetails()}${this.cutSummary() ? ` · ${this.cutSummary()}` : ''}`
          : 'Henüz bir renk seçmedin.';

        if (this.giftPanel) this.giftPanel.hidden = !(giftRequired && boxReady);
        this.giftOptions?.querySelectorAll('[data-gift-color]').forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.giftColor === this.giftColor ? 'true' : 'false');
        });

        this.addButton.disabled = !ready || this.pending;
        const price = this.products[this.productKey()]?.price;
        const priceNode = this.addButton.querySelector('strong');
        if (priceNode && Number(price) > 0) {
          priceNode.textContent = `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(Number(price) / 100)} TL`;
        }

        if (!this.pending) {
          if (remaining > 0) this.addLabel.textContent = 'RENKLERİNİ SEÇ';
          else if (variantResolving) this.addLabel.textContent = 'KOMBİNASYON DOĞRULANIYOR…';
          else if (variantError) this.addLabel.textContent = 'KOMBİNASYON DOĞRULANAMADI';
          else if (!boxReady) this.addLabel.textContent = 'BU KOMBİNASYON MEVCUT DEĞİL';
          else if (giftRequired && !giftReady) this.addLabel.textContent = 'HEDİYE RENGİNİ SEÇ';
          else if (giftRequired) this.addLabel.textContent = 'KUTU + HEDİYEYİ SEPETE EKLE';
          else this.addLabel.textContent = this.pack === 5 ? '5’Lİ KUTUYU SEPETE EKLE' : '3’LÜ KUTUYU SEPETE EKLE';
        }

        this.renderBox();
        this.updateMobilePreview();
      }

      track(payload) {
        const name = this.dataset.klaviyoEvent || 'Daily Nuuds Box Added';
        window._learnq = window._learnq || [];
        window._learnq.push(['track', name, payload]);
      }

      async addToCart() {
        if (this.pending) return;
        const variant = this.selectedVariant();
        if (!variant || variant.available === false) return;

        const items = [{
          id: numericId(variant.id),
          quantity: 1,
          properties: {
            '_Paket Tipi': `KUTU - ${this.pack}'li`,
            '_Kutu İçeriği': this.variantTitle(),
            '_Kesim Dağılımı': this.cutSummary(),
            '_Seçimler': this.selectionDetails(),
            '_Bundle Parent': this.products[this.productKey()]?.handle || '',
            'image-swatches-1': this.variantTitle(),
            '_Kaynak': 'Ana sayfa kutu kurucu'
          }
        }];

        if (this.pack === 5 && this.giftEnabled) {
          const giftVariant = this.findGiftVariant(this.giftColor);
          if (!giftVariant || giftVariant.available === false) return;
          items.push({
            id: numericId(giftVariant.id),
            quantity: 1,
            properties: {
              '_Hediye': '5’li kutu Classic Bikini hediyesi',
              '_Hediye Rengi': this.giftColor,
              '_Kaynak': 'Ana sayfa kutu kurucu'
            }
          });
        }

        if (items.some((item) => !item.id)) return;
        this.pending = true;
        this.addButton.disabled = true;
        this.addLabel.textContent = 'SEPETE EKLENİYOR…';
        this.updateMobilePreview();
        this.error.hidden = true;
        this.error.textContent = '';

        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');

          this.track({
            builder_version: 'homepage-mixed-cut-v2',
            package_size: this.pack,
            package_contents: this.variantTitle(),
            cut_distribution: this.cutSummary(),
            selection_details: this.selectionDetails(),
            gift_color: this.pack === 5 && this.giftEnabled ? this.giftColor : '',
            page_url: window.location.href
          });

          const cartUrl = this.dataset.cartUrl || '/cart';
          const giftCode = this.dataset.giftCode || '';
          const destination = this.pack === 5 && this.giftEnabled && giftCode
            ? `/discount/${encodeURIComponent(giftCode)}?redirect=${encodeURIComponent(cartUrl)}`
            : cartUrl;
          window.location.assign(destination);
        } catch (error) {
          this.pending = false;
          this.error.textContent = error.message || 'Ürün sepete eklenemedi.';
          this.error.hidden = false;
          this.render();
        }
      }
    }

    if (!customElements.get('dn-home-box-builder')) {
      customElements.define('dn-home-box-builder', DnHomeBoxBuilder);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-landing-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('daily-nuuds-landing')) return;

    class DailyNuudsLanding extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.fitAnswers = {};
        this.initScrollLinks();
        this.initFitTest();
        this.initComparison();
        this.initBuilder();
      }

      motionBehavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      initScrollLinks() {
        this.querySelectorAll('[data-scroll-to]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const target = this.querySelector(link.getAttribute('href'));
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: this.motionBehavior(), block: 'start' });
          });
        });
      }

      initFitTest() {
        this.fitTest = this.querySelector('[data-fit-test]');
        if (!this.fitTest) return;
        this.fitSteps = Array.from(this.fitTest.querySelectorAll('[data-fit-step]'));
        this.fitResult = this.fitTest.querySelector('[data-fit-result]');
        this.fitSummary = this.fitTest.querySelector('[data-fit-summary]');
        this.fitProgressLabel = this.fitTest.querySelector('[data-fit-progress-label]');
        this.fitProgressBar = this.fitTest.querySelector('[data-fit-progress-bar]');

        this.fitTest.querySelectorAll('[data-fit-answer]').forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
          button.addEventListener('click', () => this.selectFitAnswer(button));
        });

        this.fitTest.querySelectorAll('[data-fit-back]').forEach((button) => {
          button.addEventListener('click', () => this.showFitStep(Number(button.dataset.fitBack)));
        });

        this.fitTest.querySelector('[data-fit-restart]')?.addEventListener('click', () => this.restartFitTest());
      }

      selectFitAnswer(button) {
        const key = button.dataset.fitKey;
        const value = button.dataset.fitValue;
        const step = Number(button.closest('[data-fit-step]')?.dataset.fitStep || 1);
        if (!key || !value) return;

        this.fitAnswers[key] = value;
        button.parentElement?.querySelectorAll('[data-fit-answer]').forEach((choice) => {
          choice.setAttribute('aria-pressed', choice === button ? 'true' : 'false');
        });

        if (step < 3) {
          this.showFitStep(step + 1);
          return;
        }

        this.showFitResult();
      }

      showFitStep(stepNumber) {
        this.fitSteps.forEach((step) => {
          step.hidden = Number(step.dataset.fitStep) !== stepNumber;
        });
        if (this.fitResult) this.fitResult.hidden = true;
        if (this.fitProgressLabel) this.fitProgressLabel.textContent = `${stepNumber} / 3`;
        if (this.fitProgressBar) this.fitProgressBar.style.width = `${(stepNumber / 3) * 100}%`;
      }

      showFitResult() {
        this.fitSteps.forEach((step) => {
          step.hidden = true;
        });
        if (this.fitResult) this.fitResult.hidden = false;
        if (this.fitProgressLabel) this.fitProgressLabel.textContent = '3 / 3';
        if (this.fitProgressBar) this.fitProgressBar.style.width = '100%';

        if (this.fitSummary) {
          this.fitSummary.replaceChildren();
          Object.values(this.fitAnswers).forEach((answer) => {
            const item = document.createElement('span');
            item.textContent = answer;
            this.fitSummary.appendChild(item);
          });
        }

        this.track(this.dataset.klaviyoFitEvent || 'Daily Nuuds Fit Test Completed', {
          fit_version: 'daily-nuuds-fit-v2',
          size: this.fitAnswers.size || '',
          comfort: this.fitAnswers.comfort || '',
          stretch: this.fitAnswers.stretch || '',
          landing_url: window.location.origin + window.location.pathname
        });
      }

      restartFitTest() {
        this.fitAnswers = {};
        this.fitTest?.querySelectorAll('[data-fit-answer]').forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });
        this.showFitStep(1);
      }

      initComparison() {
        this.querySelectorAll('[data-comparison]').forEach((comparison) => {
          const range = comparison.querySelector('[data-comparison-range]');
          if (!range) return;
          const update = () => {
            comparison.style.setProperty('--comparison-position', `${range.value}%`);
          };
          range.addEventListener('input', update);
          update();
        });
      }

      initBuilder() {
        this.builder = this.querySelector('[data-box-builder]');
        if (!this.builder) return;

        this.products = {};
        this.querySelectorAll('[data-builder-product-json]').forEach((script) => {
          try {
            this.products[script.dataset.builderProductJson] = JSON.parse(script.textContent);
          } catch (error) {
            this.products[script.dataset.builderProductJson] = null;
          }
        });

        this.packSize = 5;
        this.colorOrder = [];
        this.selectionSequence = [];
        this.colors = {};
        this.builder.querySelectorAll('[data-color]').forEach((card) => {
          const name = card.dataset.color;
          const enabled = card.dataset.colorEnabled !== 'false' && !card.classList.contains('is-disabled');
          this.colorOrder.push(name);
          this.colors[name] = {
            count: 0,
            enabled,
            value: card.dataset.colorValue || '#999999',
            image: card.dataset.colorImage || '',
            previewImage: card.querySelector('.dn-color__image img')?.currentSrc
              || card.querySelector('.dn-color__image img')?.getAttribute('src')
              || '',
            card
          };
        });

        this.countEl = this.builder.querySelector('[data-builder-count]');
        this.messageEl = this.builder.querySelector('[data-builder-message]');
        this.selectionEl = this.builder.querySelector('[data-builder-selection]');
        this.addButtons = Array.from(this.builder.querySelectorAll('[data-builder-add]'));
        this.addLabels = Array.from(this.builder.querySelectorAll('[data-builder-add-label]'));
        this.priceEls = Array.from(this.builder.querySelectorAll('[data-builder-price]'));
        this.errorEl = this.builder.querySelector('[data-builder-error]');
        this.mobileTray = this.builder.querySelector('[data-mobile-tray]');
        this.trayTitle = this.builder.querySelector('[data-tray-title]');
        this.trayStatus = this.builder.querySelector('[data-tray-status]');
        this.trayProgress = this.builder.querySelector('[data-tray-progress]');
        this.singlePreviews = Array.from(this.builder.querySelectorAll('[data-single-preview]'));

        this.builder.querySelectorAll('[data-pack-size]').forEach((button) => {
          button.addEventListener('click', () => this.setPackSize(Number(button.dataset.packSize)));
        });

        this.builder.querySelectorAll('[data-color]').forEach((card) => {
          card.querySelector('[data-color-add]')?.addEventListener('click', () => this.changeColor(card.dataset.color, 1));
          card.querySelector('[data-color-plus]')?.addEventListener('click', () => this.changeColor(card.dataset.color, 1));
          card.querySelector('[data-color-minus]')?.addEventListener('click', () => this.changeColor(card.dataset.color, -1));
        });

        this.addButtons.forEach((button) => {
          button.addEventListener('click', () => this.addBoxToCart());
        });
        this.builder.querySelector('[data-tray-toggle]')?.addEventListener('click', (event) => {
          const collapsed = this.mobileTray?.classList.toggle('is-collapsed');
          event.currentTarget.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });

        this.setPackSize(5);
      }

      setPackSize(size) {
        if (![1, 3, 5].includes(size)) return;
        this.packSize = size;
        this.builder.classList.toggle('is-single-pack', size === 1);
        Object.values(this.colors).forEach((color) => {
          color.count = 0;
        });
        this.selectionSequence = [];
        this.builder.querySelectorAll('[data-pack-size]').forEach((button) => {
          button.setAttribute('aria-pressed', Number(button.dataset.packSize) === size ? 'true' : 'false');
        });
        this.renderBuilder();
      }

      totalSelected() {
        return Object.values(this.colors).reduce((sum, color) => sum + color.count, 0);
      }

      changeColor(name, delta) {
        const color = this.colors[name];
        if (!color?.enabled) return;
        const total = this.totalSelected();
        if (delta > 0 && total >= this.packSize) return;
        if (delta < 0 && color.count <= 0) return;
        if (delta > 0) {
          color.count += 1;
          this.selectionSequence.push(name);
        } else {
          color.count -= 1;
          const sequenceIndex = this.selectionSequence.lastIndexOf(name);
          if (sequenceIndex >= 0) this.selectionSequence.splice(sequenceIndex, 1);
        }
        this.renderBuilder();
      }

      buildVariantValue() {
        return this.colorOrder
          .filter((name) => this.colors[name].count > 0)
          .map((name) => `${this.colors[name].count} ${name}`)
          .join(' + ');
      }

      buildLegacyValue() {
        return this.colorOrder
          .filter((name) => this.colors[name].count > 0)
          .map((name) => `${name} | ${this.colors[name].count}`)
          .join(', ');
      }

      selectedColorsInOrder() {
        return this.selectionSequence.map((name) => {
          const color = this.colors[name];
          return {
            name,
            value: color.value,
            image: color.image,
            previewImage: color.previewImage
          };
        });
      }

      selectedVariant() {
        if (this.totalSelected() !== this.packSize) return null;
        const product = this.products[String(this.packSize)];
        const variants = product?.variants || [];
        const expected = this.packSize === 1
          ? this.selectionSequence[0] || ''
          : this.buildVariantValue();
        return variants.find((variant) => {
          const value = variant.option1 || variant.options?.[0] || variant.public_title || variant.title;
          return value === expected;
        }) || null;
      }

      renderBuilder() {
        const total = this.totalSelected();
        const remaining = Math.max(this.packSize - total, 0);
        const selected = this.selectedColorsInOrder();
        const variant = this.selectedVariant();

        Object.entries(this.colors).forEach(([name, color]) => {
          const card = color.card;
          card.classList.toggle('is-selected', color.count > 0);
          const count = card.querySelector('[data-color-count]');
          const minus = card.querySelector('[data-color-minus]');
          const plus = card.querySelector('[data-color-plus]');
          const add = card.querySelector('[data-color-add]');
          if (count) count.textContent = String(color.count);
          if (minus) minus.disabled = color.count <= 0;
          if (plus) plus.disabled = !color.enabled || total >= this.packSize;
          if (add) add.disabled = !color.enabled || total >= this.packSize;
        });

        if (this.countEl) this.countEl.textContent = `${total} / ${this.packSize}`;
        if (this.messageEl) {
          this.messageEl.textContent = remaining === 0
            ? variant?.available === false
              ? 'Bu seçim tükendi.'
              : this.packSize === 1
                ? 'Seçimin hazır.'
                : 'Kutun hazır.'
            : this.packSize === 1
              ? 'Bir renk seç.'
              : `${remaining} renk daha seç.`;
        }

        if (this.selectionEl) {
          this.selectionEl.textContent = total > 0
            ? this.packSize === 1
              ? this.selectionSequence[0]
              : this.buildVariantValue()
            : 'Henüz bir renk seçmedin.';
        }

        this.priceEls.forEach((price) => {
          price.textContent = this.builder.dataset[`price${this.packSize}`] || '';
        });

        const ready = Boolean(variant) && variant.available !== false;
        this.addButtons.forEach((button) => {
          button.disabled = !ready;
        });
        this.addLabels.forEach((label) => {
          label.textContent = ready
            ? 'SEPETE EKLE'
            : total === this.packSize
              ? 'KOMBİNASYON BULUNAMADI'
              : this.packSize === 1
                ? 'RENGİNİ SEÇ'
                : 'KUTUYU TAMAMLA';
        });

        if (this.errorEl) {
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
        }

        this.renderBoxVisuals(selected);
        this.renderSinglePreviews(selected);
        this.renderMobileTray(total, remaining);
      }

      renderSinglePreviews(selected) {
        const selectedImage = selected[0]?.previewImage || this.builder.dataset.singleImage || '';
        this.singlePreviews.forEach((preview) => {
          preview.hidden = this.packSize !== 1;
          const image = preview.querySelector('.dn-single-preview__image');
          if (image && selectedImage && image.getAttribute('src') !== selectedImage) {
            image.setAttribute('src', selectedImage);
            image.removeAttribute('srcset');
          }
        });
      }

      renderBoxVisuals(selected) {
        const imageUrl = this.builder.dataset[`boxImage${this.packSize}`] || '';
        this.builder.querySelectorAll('[data-box-visual]').forEach((visual) => {
          visual.classList.toggle('is-pack-3', this.packSize === 3);
          visual.classList.toggle('is-pack-5', this.packSize === 5);
          const image = visual.querySelector('.dn-box-visual__image');
          if (image && imageUrl && image.getAttribute('src') !== imageUrl) {
            image.setAttribute('src', imageUrl);
            image.removeAttribute('srcset');
          }
          visual.querySelectorAll('[data-box-slot]').forEach((slot, index) => {
            const color = selected[index];
            slot.classList.toggle('is-filled', Boolean(color));
            slot.style.setProperty('--slot-color', color?.value || '#4c2018');
            slot.style.setProperty('--slot-image', color?.image ? `url("${color.image}")` : 'none');
            slot.setAttribute('aria-label', color?.name || 'Boş kutu gözü');
          });
        });
      }

      renderMobileTray(total, remaining) {
        if (!this.mobileTray) return;
        const visible = total > 0;
        this.mobileTray.hidden = !visible;
        this.classList.toggle('is-tray-visible', visible);
        if (!visible) return;
        if (this.trayTitle) {
          this.trayTitle.textContent = this.packSize === 1
            ? `Tekli seçimin · ${total}/1`
            : `Kutuna ekleniyor · ${total}/${this.packSize}`;
        }
        if (this.trayStatus) {
          this.trayStatus.textContent = remaining === 0
            ? this.packSize === 1 ? 'Seçimin hazır.' : 'Kutun hazır.'
            : this.packSize === 1 ? 'Bir renk seç.' : `${remaining} renk daha seç.`;
        }
        if (this.trayProgress) this.trayProgress.style.width = `${(total / this.packSize) * 100}%`;
      }

      async addBoxToCart() {
        const variant = this.selectedVariant();
        if (!variant || variant.available === false || this.addButtons.length === 0) return;

        const originalLabels = this.addLabels.map((label) => label.textContent || 'SEPETE EKLE');
        this.addButtons.forEach((button) => {
          button.disabled = true;
        });
        this.addLabels.forEach((label) => {
          label.textContent = 'SEPETE EKLENİYOR…';
        });
        if (this.trayStatus) this.trayStatus.textContent = 'Sepete ekleniyor…';

        const formData = new FormData();
        const variantId = String(variant.id).split('/').pop();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('properties[_Paket Tipi]', this.packSize === 1 ? 'TEKLİ / ZARFLI' : `KUTU - ${this.packSize}'li`);
        if (this.packSize === 1) {
          formData.append('properties[_Renk]', this.selectionSequence[0] || '');
        } else {
          formData.append('properties[_Kutu İçeriği]', this.buildVariantValue());
          formData.append('properties[image-swatches-1]', this.buildLegacyValue());
        }
        formData.append('properties[_Landing Sayfası]', 'Daily Nuuds Landing v2');
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);

        try {
          const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
          }

          document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
            bubbles: true,
            detail: {
              response: data,
              sourceId: `DailyNuudsBuilder-${this.dataset.sectionId}`
            }
          }));

          this.track(this.dataset.klaviyoBuilderEvent || 'Daily Nuuds Box Added', {
            builder_version: 'daily-nuuds-builder-v2',
            package_size: this.packSize,
            package_contents: this.buildVariantValue(),
            variant_id: variantId,
            variant_title: variant.title || variant.option1 || '',
            landing_url: window.location.origin + window.location.pathname
          });

          this.addLabels.forEach((label) => {
            label.textContent = 'SEPETE EKLENDİ ✓';
          });
          if (this.trayTitle) this.trayTitle.textContent = 'Sepete eklendi ✓';
          if (this.trayStatus) this.trayStatus.textContent = this.buildVariantValue();
        } catch (error) {
          if (this.errorEl) {
            this.errorEl.textContent = error.message || 'Ürün sepete eklenemedi.';
            this.errorEl.hidden = false;
          }
          this.addLabels.forEach((label, index) => {
            label.textContent = originalLabels[index] || 'SEPETE EKLE';
          });
          if (this.trayStatus) this.trayStatus.textContent = 'Bir sorun oluştu. Tekrar dene.';
        } finally {
          window.setTimeout(() => {
            this.renderBuilder();
          }, 1800);
        }
      }

      track(eventName, payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''),
          ...payload
        });

        try {
          if (window.klaviyo && typeof window.klaviyo.track === 'function') {
            const result = window.klaviyo.track(eventName, payload);
            if (result && typeof result.catch === 'function') result.catch(() => {});
          } else {
            window._learnq = window._learnq || [];
            window._learnq.push(['track', eventName, payload]);
          }
        } catch (error) {
          return;
        }
      }
    }

    customElements.define('daily-nuuds-landing', DailyNuudsLanding);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-picker-v17"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const packTitles = {
      1: 'ZARFLARINI SEÇ',
      3: '3’LÜ KUTUNU DOLDUR',
      5: '5’Lİ KUTUNU DOLDUR + HEDİYENİ SEÇ'
    };

    const variantValue = (variant) => (
      variant?.option1 || variant?.options?.[0] || variant?.public_title || variant?.title || ''
    );

    const numericId = (id) => String(id || '').split('/').pop();

    const normalized = (value) => String(value || '').trim().toLocaleLowerCase('tr-TR');

    const makeImage = (src, alt = '') => {
      const image = document.createElement('img');
      image.src = src;
      image.alt = alt;
      image.loading = 'eager';
      image.decoding = 'async';
      return image;
    };

    const formatTry = (amountInCents) => `${new Intl.NumberFormat('tr-TR', {
      maximumFractionDigits: 0
    }).format((Number(amountInCents) || 0) / 100)} TL`;

    const installPicker = (landing, config) => {
      const builder = landing.builder;
      if (!builder || builder.dataset.pickerV17Ready === 'true') return true;

      const packHost = builder.querySelector('.dn-builder__packs');
      const controls = builder.querySelector('.dn-builder__controls');
      const preview = builder.querySelector('.dn-builder__preview');
      const status = builder.querySelector('.dn-builder__status');
      const colors = builder.querySelector('.dn-builder__colors');
      const mainButton = controls?.querySelector(':scope > [data-builder-add]');
      const error = controls?.querySelector(':scope > [data-builder-error]');
      if (!packHost || !controls || !preview || !status || !colors || !mainButton || !error) return false;

      const assets = {
        envelope: config.dataset.envelopeImage || builder.dataset.singleImage || '',
        pack3: config.dataset.packCard3 || builder.dataset.boxImage3 || '',
        pack5: config.dataset.packCard5 || builder.dataset.boxImage5 || ''
      };
      const giftEnabled = config.dataset.giftEnabled === 'true' && Boolean(config.dataset.giftCode);
      const giftCode = config.dataset.giftCode || '';

      packHost.querySelectorAll('[data-pack-size]').forEach((button) => {
        const size = Number(button.dataset.packSize);
        const source = size === 1 ? assets.envelope : size === 3 ? assets.pack3 : assets.pack5;
        let visual = button.querySelector('.dn-picker-v17__card-visual');
        if (!visual) {
          visual = document.createElement('span');
          visual.className = 'dn-picker-v17__card-visual';
          visual.setAttribute('aria-hidden', 'true');
          button.append(visual);
        }
        visual.replaceChildren();
        if (source) visual.append(makeImage(source, ''));
        if (size === 5 && giftEnabled && !button.querySelector('.dn-picker-v17__gift-badge')) {
          const badge = document.createElement('span');
          badge.className = 'dn-picker-v17__gift-badge';
          badge.textContent = '+ 1 HEDİYE';
          button.append(badge);
        }
      });

      const dialog = document.createElement('dialog');
      dialog.className = 'dn-picker-v17';
      dialog.setAttribute('aria-labelledby', `DnPickerV17Title-${landing.dataset.sectionId || 'main'}`);
      dialog.innerHTML = `
        <div class="dn-picker-v17__shell">
          <header class="dn-picker-v17__header">
            <p id="DnPickerV17Title-${landing.dataset.sectionId || 'main'}" data-picker-title></p>
            <button type="button" class="dn-picker-v17__close" data-picker-close aria-label="Pencereyi kapat">×</button>
          </header>
          <div class="dn-picker-v17__body">
            <div class="dn-picker-v17__controls" data-picker-controls></div>
            <div class="dn-picker-v17__preview" data-picker-preview></div>
          </div>
          <footer class="dn-picker-v17__footer" data-picker-footer></footer>
        </div>
      `;

      const controlsHost = dialog.querySelector('[data-picker-controls]');
      const previewHost = dialog.querySelector('[data-picker-preview]');
      const footer = dialog.querySelector('[data-picker-footer]');
      const title = dialog.querySelector('[data-picker-title]');
      controlsHost.append(status, colors);
      previewHost.append(preview);
      footer.append(mainButton, error);
      builder.append(dialog);

      const envelopeStack = document.createElement('div');
      envelopeStack.className = 'dn-envelope-stack-v17';
      envelopeStack.setAttribute('aria-label', 'Seçilen zarflar');
      preview.insertBefore(envelopeStack, preview.querySelector('.dn-builder__selection'));

      let giftPanel = null;
      let giftOptions = null;
      if (giftEnabled) {
        giftPanel = document.createElement('section');
        giftPanel.className = 'dn-gift-v17';
        giftPanel.hidden = true;
        giftPanel.innerHTML = `
          <div class="dn-gift-v17__heading">
            <strong>Hediye zarfının rengini seç</strong>
            <span>0 TL</span>
          </div>
          <div class="dn-gift-v17__options" role="group" aria-label="Hediye rengi"></div>
        `;
        controlsHost.append(giftPanel);
        giftOptions = giftPanel.querySelector('.dn-gift-v17__options');
      }

      const originalSetPackSize = landing.setPackSize.bind(landing);
      const originalChangeColor = landing.changeColor.bind(landing);
      const originalRenderBuilder = landing.renderBuilder.bind(landing);
      const states = { 1: null, 3: null, 5: null };
      let activePack = null;
      let giftColor = '';
      let requestPending = false;

      const singleVariants = () => landing.products?.['1']?.variants || [];

      const findSingleVariant = (name) => singleVariants().find(
        (variant) => normalized(variantValue(variant)) === normalized(name)
      ) || null;

      const snapshotState = () => ({
        counts: Object.fromEntries(Object.entries(landing.colors).map(([name, color]) => [name, color.count])),
        sequence: [...landing.selectionSequence],
        giftColor
      });

      const restoreState = (state) => {
        Object.entries(landing.colors).forEach(([name, color]) => {
          color.count = Number(state?.counts?.[name]) || 0;
        });
        landing.selectionSequence = Array.isArray(state?.sequence) ? [...state.sequence] : [];
        giftColor = state?.giftColor || '';
      };

      const syncAvailability = () => {
        Object.entries(landing.colors).forEach(([name, color]) => {
          const variant = findSingleVariant(name);
          const available = Boolean(variant) && variant.available !== false;
          color.enabled = available;
          color.card.classList.toggle('is-disabled', !available);
          color.card.toggleAttribute('aria-disabled', !available);
          const add = color.card.querySelector('[data-color-add]');
          if (add) add.disabled = !available;
        });
      };

      syncAvailability();

      if (giftOptions) {
        Object.entries(landing.colors).forEach(([name, color]) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.className = 'dn-gift-v17__option';
          option.dataset.giftColor = name;
          option.setAttribute('aria-pressed', 'false');
          option.style.setProperty('--dn-gift-color', color.value);
          if (assets.envelope) option.append(makeImage(assets.envelope, ''));
          const dot = document.createElement('i');
          dot.className = 'dn-gift-v17__dot';
          dot.setAttribute('aria-hidden', 'true');
          const label = document.createElement('span');
          label.textContent = name;
          option.append(dot, label);
          option.addEventListener('click', () => {
            const variant = findSingleVariant(name);
            if (!variant || variant.available === false) return;
            giftColor = name;
            states[5] = snapshotState();
            landing.renderBuilder();
          });
          giftOptions.append(option);
        });
      }

      const renderEnvelopes = () => {
        envelopeStack.replaceChildren();
        const selected = landing.selectedColorsInOrder();
        const entries = selected.length > 0 ? selected : [null];
        entries.forEach((selectedColor) => {
          const item = document.createElement('span');
          item.className = 'dn-envelope-item-v17';
          item.style.setProperty('--dn-envelope-color', selectedColor?.value || '#d8d0c7');
          if (assets.envelope) item.append(makeImage(assets.envelope, selectedColor?.name || 'Daily Nuuds zarf'));
          const label = document.createElement('span');
          const dot = document.createElement('i');
          dot.setAttribute('aria-hidden', 'true');
          label.append(dot, document.createTextNode(selectedColor?.name || 'Zarfını seç'));
          item.append(label);
          envelopeStack.append(item);
        });
      };

      const singleReady = () => {
        if (landing.totalSelected() < 1) return false;
        return landing.colorOrder
          .filter((name) => landing.colors[name].count > 0)
          .every((name) => {
            const variant = findSingleVariant(name);
            return Boolean(variant) && variant.available !== false;
          });
      };

      const singleTotal = () => landing.colorOrder.reduce((sum, name) => {
        const variant = findSingleVariant(name);
        return sum + ((Number(variant?.price) || 0) * landing.colors[name].count);
      }, 0);

      const updatePrice = () => {
        const amount = activePack === 1
          ? singleTotal()
          : Number(landing.products?.[String(activePack)]?.price || landing.selectedVariant()?.price || 0);
        const fallback = builder.dataset[`price${activePack}`] || '';
        landing.priceEls.forEach((element) => {
          element.textContent = amount > 0 ? formatTry(amount) : fallback;
        });
      };

      const updateUi = () => {
        const total = landing.totalSelected();
        const remaining = Math.max((activePack || 0) - total, 0);
        const isSingle = activePack === 1;
        const boxVariant = activePack && !isSingle ? landing.selectedVariant() : null;
        const boxReady = Boolean(boxVariant) && boxVariant.available !== false && total === activePack;
        const giftVariant = giftColor ? findSingleVariant(giftColor) : null;
        const giftRequired = activePack === 5 && giftEnabled;
        const giftReady = !giftRequired || Boolean(giftVariant) && giftVariant.available !== false;
        const ready = isSingle ? singleReady() : boxReady && giftReady;

        builder.classList.add('is-picker-v17-ready');
        dialog.classList.toggle('is-single', isSingle);
        if (title) title.textContent = packTitles[activePack] || '';

        if (!activePack) {
          packHost.querySelectorAll('[data-pack-size]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        }

        if (isSingle) {
          Object.values(landing.colors).forEach((color) => {
            const minus = color.card.querySelector('[data-color-minus]');
            const plus = color.card.querySelector('[data-color-plus]');
            const add = color.card.querySelector('[data-color-add]');
            if (minus) minus.disabled = color.count <= 0;
            if (plus) plus.disabled = !color.enabled;
            if (add) add.disabled = !color.enabled;
          });
          if (landing.countEl) landing.countEl.textContent = `${total} adet`;
          if (landing.messageEl) landing.messageEl.textContent = total > 0 ? 'Zarfların hazır.' : 'Renk ve adet seç.';
          if (landing.selectionEl) landing.selectionEl.textContent = total > 0 ? landing.buildVariantValue() : 'İlk zarfın burada görünecek.';
          renderEnvelopes();
        }

        if (giftPanel) giftPanel.hidden = !(giftRequired && boxReady);
        giftOptions?.querySelectorAll('[data-gift-color]').forEach((option) => {
          const variant = findSingleVariant(option.dataset.giftColor);
          option.disabled = !variant || variant.available === false;
          option.setAttribute('aria-pressed', option.dataset.giftColor === giftColor ? 'true' : 'false');
        });

        if (activePack === 5 && boxReady && giftEnabled) {
          if (landing.messageEl) landing.messageEl.textContent = giftReady
            ? `${giftColor} hediyen hazır.`
            : 'Kutun hazır. Şimdi hediye rengini seç.';
          if (landing.selectionEl && giftReady) {
            landing.selectionEl.textContent = `${landing.buildVariantValue()} + Hediye: ${giftColor}`;
          }
        }

        const label = mainButton.querySelector('[data-builder-add-label]');
        mainButton.hidden = false;
        mainButton.disabled = !ready || requestPending;
        if (label && !requestPending) {
          if (!activePack) label.textContent = 'ÖNCE PAKETİNİ SEÇ';
          else if (isSingle) label.textContent = ready ? 'ZARFLARI SEPETE EKLE' : 'RENGİNİ SEÇ';
          else if (activePack === 5 && boxReady && giftEnabled && !giftReady) label.textContent = 'HEDİYE RENGİNİ SEÇ';
          else if (ready && giftRequired) label.textContent = 'KUTU + HEDİYEYİ SEPETE EKLE';
          else if (ready) label.textContent = activePack === 5 ? '5’Lİ KUTUYU SEPETE EKLE' : '3’LÜ KUTUYU SEPETE EKLE';
          else if (total === activePack && !boxVariant) label.textContent = 'BU KOMBİNASYON MEVCUT DEĞİL';
          else label.textContent = `KUTUYU TAMAMLA · ${remaining} KALDI`;
        }

        updatePrice();

        if (landing.mobileTray) {
          landing.mobileTray.classList.toggle('is-picker-resume', !dialog.open && total > 0);
          if (landing.trayTitle && total > 0) {
            landing.trayTitle.textContent = isSingle
              ? `Zarflarına devam et · ${total} adet`
              : `${activePack}’lü kutuna devam et · ${total}/${activePack}`;
          }
        }
      };

      const openPicker = () => {
        if (!activePack || dialog.open) return;
        landing.classList.add('is-picker-modal-open');
        landing.mobileTray?.classList.remove('is-picker-resume');
        dialog.showModal();
        updateUi();
        requestAnimationFrame(() => dialog.querySelector('[data-picker-close]')?.focus({ preventScroll: true }));
      };

      landing.renderBuilder = function renderBuilderV17() {
        originalRenderBuilder();
        if (activePack) states[activePack] = snapshotState();
        updateUi();
      };

      landing.setPackSize = function setPackSizeV17(size) {
        if (![1, 3, 5].includes(size)) return;
        if (activePack && activePack !== size) states[activePack] = snapshotState();
        if (activePack !== size) {
          activePack = size;
          originalSetPackSize(size);
          restoreState(states[size]);
          this.renderBuilder();
        } else {
          this.renderBuilder();
        }
        openPicker();
      };

      landing.changeColor = function changeColorV17(name, delta) {
        if (this.packSize !== 1) {
          originalChangeColor(name, delta);
          return;
        }
        const color = this.colors[name];
        if (!color?.enabled || delta < 0 && color.count <= 0) return;
        if (delta > 0) {
          color.count += 1;
          this.selectionSequence.push(name);
        } else {
          color.count -= 1;
          const index = this.selectionSequence.lastIndexOf(name);
          if (index >= 0) this.selectionSequence.splice(index, 1);
        }
        this.renderBuilder();
      };

      landing.addBoxToCart = async function addBoxToCartV17() {
        if (!activePack || requestPending) return;
        const items = [];
        if (activePack === 1) {
          this.colorOrder.filter((name) => this.colors[name].count > 0).forEach((name) => {
            const variant = findSingleVariant(name);
            if (!variant || variant.available === false) return;
            items.push({
              id: numericId(variant.id),
              quantity: this.colors[name].count,
              properties: {
                '_Paket Tipi': 'TEKLİ / ZARFLI',
                '_Renk': name,
                '_Landing Sayfası': 'Daily Nuuds Landing v2'
              }
            });
          });
        } else {
          const variant = this.selectedVariant();
          if (variant && variant.available !== false) {
            items.push({
              id: numericId(variant.id),
              quantity: 1,
              properties: {
                '_Paket Tipi': `KUTU - ${activePack}'li`,
                '_Kutu İçeriği': this.buildVariantValue(),
                'image-swatches-1': this.buildLegacyValue(),
                '_Landing Sayfası': 'Daily Nuuds Landing v2'
              }
            });
          }
          if (activePack === 5 && giftEnabled) {
            const giftVariant = findSingleVariant(giftColor);
            if (!giftVariant || giftVariant.available === false) return;
            items.push({
              id: numericId(giftVariant.id),
              quantity: 1,
              properties: {
                '_Hediye': '5’li kutu hediyesi',
                '_Hediye Rengi': giftColor,
                '_Landing Sayfası': 'Daily Nuuds Landing v2'
              }
            });
          }
        }
        if (items.length === 0) return;

        const label = mainButton.querySelector('[data-builder-add-label]');
        requestPending = true;
        mainButton.disabled = true;
        if (label) label.textContent = 'SEPETE EKLENİYOR…';
        error.hidden = true;
        error.textContent = '';

        try {
          const response = await fetch(config.dataset.cartAddUrl || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');

          this.track(this.dataset.klaviyoBuilderEvent || 'Daily Nuuds Box Added', {
            builder_version: 'daily-nuuds-picker-v17',
            package_size: activePack,
            package_contents: this.buildVariantValue(),
            gift_color: activePack === 5 && giftEnabled ? giftColor : '',
            landing_url: window.location.origin + window.location.pathname
          });

          const cartUrl = config.dataset.cartUrl || '/cart';
          const destination = activePack === 5 && giftEnabled
            ? `/discount/${encodeURIComponent(giftCode)}?redirect=${encodeURIComponent(cartUrl)}`
            : cartUrl;
          window.location.assign(destination);
        } catch (requestError) {
          requestPending = false;
          error.textContent = requestError.message || 'Ürün sepete eklenemedi.';
          error.hidden = false;
          updateUi();
        }
      };

      dialog.querySelector('[data-picker-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        landing.classList.remove('is-picker-modal-open');
        if (activePack) states[activePack] = snapshotState();
        updateUi();
      });

      landing.mobileTray?.addEventListener('click', (event) => {
        if (dialog.open || landing.totalSelected() < 1) return;
        event.preventDefault();
        event.stopPropagation();
        openPicker();
      }, true);

      Object.values(landing.colors).forEach((color) => {
        color.count = 0;
      });
      landing.selectionSequence = [];
      packHost.querySelectorAll('[data-pack-size]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      mainButton.hidden = false;
      mainButton.disabled = true;
      landing.mobileTray?.setAttribute('hidden', '');
      builder.dataset.pickerV17Ready = 'true';
      updateUi();
      return true;
    };

    const install = (config) => {
      if (config.dataset.installed === 'true') return true;
      const landing = document.querySelector('daily-nuuds-landing');
      const visualConfig = document.querySelector('.dn-box-v5-config[data-installed="true"]');
      const polishConfig = document.querySelector('.dn-polish-v9-config[data-installed="true"]');
      if (!landing?.builder || !visualConfig || !polishConfig) return false;
      const installed = installPicker(landing, config);
      if (installed) config.dataset.installed = 'true';
      return installed;
    };

    const initialize = () => {
      document.querySelectorAll('.dn-picker-v17-config').forEach((config) => {
        let attempts = 0;
        const tryInstall = () => {
          attempts += 1;
          if (install(config) || attempts >= 100) return;
          window.setTimeout(tryInstall, 80);
        };
        tryInstall();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-polish-v9"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const colorSlugs = {
      'Hot Cocoa': 'hot-cocoa',
      'Pepper Red': 'pepper-red',
      'Bare Black': 'bare-black',
      'Nuud Beige': 'nuud-beige',
      'Sky Blue': 'sky-blue'
    };

    const applyLifeImages = (landing, urls) => {
      const strip = landing.querySelector('.dn-life__strip');
      if (!strip) return;

      const figures = Array.from(strip.querySelectorAll('.dn-life__image'));
      const source = figures.at(-1);

      while (figures.length < urls.length && source) {
        const clone = source.cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        strip.append(clone);
        figures.push(clone);
      }

      figures.forEach((figure, index) => {
        const url = urls[index];
        if (!url) {
          figure.hidden = true;
          return;
        }

        figure.hidden = false;
        const image = figure.querySelector('img');
        if (!image) return;
        image.src = url;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = `Daily Nuuds Life ${index + 1}`;
        image.loading = index < 2 ? 'eager' : 'lazy';
        image.decoding = 'async';
      });
    };

    const enableWindowsScrolling = (strip) => {
      if (!strip || strip.dataset.windowsScrollReady === 'true') return;
      strip.dataset.windowsScrollReady = 'true';

      let dragging = false;
      let moved = false;
      let startX = 0;
      let startScrollLeft = 0;

      const stopDragging = (event) => {
        if (!dragging) return;
        dragging = false;
        strip.classList.remove('is-dragging');
        if (event?.pointerId !== undefined && strip.hasPointerCapture(event.pointerId)) {
          strip.releasePointerCapture(event.pointerId);
        }
      };

      strip.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScrollLeft = strip.scrollLeft;
        strip.classList.add('is-dragging');
        strip.setPointerCapture(event.pointerId);
      });

      strip.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - startX;
        moved = moved || Math.abs(distance) > 3;
        strip.scrollLeft = startScrollLeft - distance;
        if (moved) event.preventDefault();
      });

      strip.addEventListener('pointerup', stopDragging);
      strip.addEventListener('pointercancel', stopDragging);
      strip.addEventListener('lostpointercapture', stopDragging);

      strip.addEventListener(
        'click',
        (event) => {
          if (!moved) return;
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        },
        true
      );

      strip.addEventListener(
        'wheel',
        (event) => {
          const hasHorizontalIntent =
            Math.abs(event.deltaX) > Math.abs(event.deltaY) ||
            (event.shiftKey && Math.abs(event.deltaY) > 0);
          if (!hasHorizontalIntent) return;

          const delta =
            Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
          if (!delta) return;

          const maxScroll = strip.scrollWidth - strip.clientWidth;
          const canMoveForward = delta > 0 && strip.scrollLeft < maxScroll - 1;
          const canMoveBackward = delta < 0 && strip.scrollLeft > 1;
          if (!canMoveForward && !canMoveBackward) return;

          event.preventDefault();
          strip.scrollLeft += delta;
        },
        { passive: false }
      );
    };

    const installThreePackVisual = (landing, config) => {
      const oldRender = landing.renderBoxVisuals.bind(landing);
      const base3 = config.getAttribute('data-base-3') || '';
      const layers = {};

      Object.entries(colorSlugs).forEach(([name, slug]) => {
        layers[name] = [1, 2, 3].map(
          (slot) => config.getAttribute(`data-layer-3-${slug}-${slot}`) || ''
        );
      });

      landing.renderBoxVisuals = function renderBoxVisualsV9(selected) {
        if (Number(this.packSize) !== 3) {
          this.builder.querySelectorAll('[data-box-visual]').forEach((visual) => {
            visual.classList.remove('is-v9-3');
          });
          oldRender(selected);
          return;
        }

        this.builder.querySelectorAll('[data-box-visual]').forEach((visual) => {
          visual.classList.add('is-pack-3', 'is-v9-3');
          visual.classList.remove('is-pack-5');

          const base = visual.querySelector('.dn-box-v5__base');
          if (base && base3 && base.getAttribute('src') !== base3) {
            base.setAttribute('src', base3);
            base.width = 2448;
            base.height = 2448;
          }

          visual.querySelectorAll('[data-box-v5-slot]').forEach((slot, index) => {
            const chosen = selected[index];
            const layerUrl = chosen ? layers[chosen.name]?.[index] || '' : '';
            const visible = index < 3 && Boolean(chosen) && Boolean(layerUrl);
            const image = slot.querySelector('.dn-box-v5__slot-image');

            slot.hidden = index >= 3;
            slot.classList.toggle('is-filled', visible);
            slot.setAttribute('aria-label', chosen?.name || 'Boş kutu gözü');

            if (!image) return;
            image.hidden = !visible;
            if (visible && image.getAttribute('src') !== layerUrl) {
              image.setAttribute('src', layerUrl);
              image.width = 2448;
              image.height = 2448;
            }
          });
        });
      };
    };

    const install = (config) => {
      if (config.dataset.installed === 'true') return true;

      const landing = document.querySelector('daily-nuuds-landing');
      const visualConfig = document.querySelector('.dn-box-v5-config[data-installed="true"]');
      if (!landing || !visualConfig || typeof landing.renderBoxVisuals !== 'function') return false;

      const lifeUrls = [1, 2, 3, 4, 5]
        .map((index) => config.getAttribute(`data-life-${index}`) || '')
        .filter(Boolean);
      const bubbleUrl = config.getAttribute('data-bubble') || '';

      if (bubbleUrl) {
        landing.style.setProperty('--dn-review-bubble', `url("${bubbleUrl}")`);
      }

      enableWindowsScrolling(landing.querySelector('.dn-life__strip'));
      installThreePackVisual(landing, config);

      config.dataset.installed = 'true';
      landing.renderBuilder();
      return true;
    };

    const initialize = () => {
      document.querySelectorAll('.dn-polish-v9-config').forEach((config) => {
        let attempts = 0;
        const tryInstall = () => {
          attempts += 1;
          if (install(config) || attempts >= 60) return;
          window.setTimeout(tryInstall, 100);
        };
        tryInstall();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-nuuds-ready-packs-v17"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.carouselReady === 'true') return;
      const track = section.querySelector('[data-ready-packs-track]');
      const previous = section.querySelector('[data-ready-packs-prev]');
      const next = section.querySelector('[data-ready-packs-next]');
      if (!track || !previous || !next) return;

      const step = () => Math.max(track.clientWidth * .78, 280);
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };

      previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      section.dataset.carouselReady = 'true';
      update();
    };

    const initializeAll = () => document.querySelectorAll('.dn-ready-packs').forEach(initialize);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('.dn-ready-packs')));
  })();

  } catch(e) { console.error(e); }
})();
})();
